import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class CspService {
  /**
   * Generate CSP configuration based on environment
   */
  static generateCSP(): string {
    const isDevelopment = !environment.production;

    // Base CSP directives
    const cspDirectives = {
      "default-src": ["'self'"],
      "script-src": [
        "'self'",
        "'unsafe-inline'",
        "https://www.googletagmanager.com",
        "https://maps.googleapis.com",
      ],
      "style-src": ["'self'", "'unsafe-inline'"],
      "img-src": ["'self'", "data:", "https:"],
      "connect-src": [
        "'self'",
        "http://localhost:*",
        "https://api.worktualize.com",
        "https://api.prj.weblineapps.com",
        "https://s3.ap-south-1.amazonaws.com",
      ],
      "font-src": ["'self'", "data:"],
      "object-src": ["'none'"],
      "base-uri": ["'self'"],
      "form-action": ["'self'"],
    };

    // Add localhost support for development
    if (isDevelopment) {
      cspDirectives["connect-src"].push("http://localhost:*");
      cspDirectives["connect-src"].push("https://localhost:*");
    }

    // Convert to CSP string format
    return Object.entries(cspDirectives)
      .map(([directive, sources]) => `${directive} ${sources.join(" ")}`)
      .join("; ");
  }

  /**
   * Apply CSP to the document
   */
  static applyCSP(): void {
    const cspContent = this.generateCSP();

    // Remove existing CSP meta tag
    const existingCSP = document.querySelector(
      'meta[http-equiv="Content-Security-Policy"]'
    );
    if (existingCSP) {
      existingCSP.remove();
    }

    // Create new CSP meta tag
    const meta = document.createElement("meta");
    meta.setAttribute("http-equiv", "Content-Security-Policy");
    meta.setAttribute("content", cspContent);
    document.head.appendChild(meta);
  }
}
